module.exports = __webpack_public_path__ + "static/media/grocery-slide-3.037ebd1d.png";